import dayjs from "dayjs";
import "dayjs/locale/pt-br";

import { Text } from "@aprosoja/ui";

type NewsCreationInfoProps = {
  categoryName: string;
  authorName: string;
  createdAt: string;
};

const NewsCreationInfo = ({
  authorName,
  categoryName,
  createdAt,
}: NewsCreationInfoProps) => {
  return (
    <div className="flex w-full justify-between items-center">
      <Text
        type="labelS"
        className="p-size-x2 bg-th-primary-color-lightest rounded-border-radius-small"
      >
        {categoryName}
      </Text>
      <div className="flex flex-col tabletSmall:flex-row items-center tabletSmall:gap-size-x4">
        <Text type="paragraphS" color="th-color-neutral-400">
          <Text type="labelS" color="th-color-neutral-400">
            {authorName}
          </Text>
        </Text>
        <Text type="paragraphS" color="th-color-neutral-400">
          {dayjs(createdAt).locale("pt-br").format("DD MMM YYYY")}
        </Text>
      </div>
    </div>
  );
};

export default NewsCreationInfo;
